<div class="center-block text-center" id="login-div">
  <div *ngIf="logOutReason">
      <h4 *ngIf="logOutReason === 'session expired'">Excuse the interruption, but you have been logged on a very long time. Please log in again so we know it’s still you.</h4>
      <h4 *ngIf="logOutReason === 'inactivity'">You have been logged out due to inactivity.</h4>
      <h4 *ngIf="logOutReason === 'double login'">It looks like you may have logged in elsewhere. If you’d like to continue in this window, please log in again.</h4>
      <h4 *ngIf="logOutReason === 'logout'">You have been logged out.</h4>
  </div>
  <h3>You must be logged in to use this application.</h3>
  <button id="login-btn" class="btn btn-primary" (click)="goToAuthorizationServer()" appFocusable>Proceed to Login</button>
</div>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/login/login.component.html